
import {
  ref,
  defineComponent,
  computed,
  useStore,
  useContext,
  Ref,
} from '@nuxtjs/composition-api'
import axios from 'axios'
import { debounce } from 'throttle-debounce'
import InputSelect from '@/components/new-design/form/InputSelect.vue'
import { Logger } from '@/composition/Logger'
export default defineComponent({
  components: { InputSelect },
  props: {},
  setup(_props, { emit }) {
    const { getters } = useStore()
    const ctx = useContext()
    const popupProperties = computed(
      () => getters['settings/getPopupCityListProperties']
    )
    const search = ref('')
    const cityList: Ref<unknown[]> = ref([])
    const pending = ref(false)
    const canFetch = computed(() => search.value.length > 2)
    const isFetchError = computed(
      () => canFetch.value && cityList.value.length === 0 && !pending.value
    )
    const suggestionsUrl = ctx.$config.SUGGESTIONS_CDI_URL

    const suggestionsClient = axios.create({
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
      timeout: 1500,
    })

    suggestionsClient.interceptors.response.use(
      function (response) {
        return response.data.suggestions
          .map((el: any) => {
            const isValid =
              el.data.qc_geo !== '5' && el.data.settlement_type !== 'промзона'
            if (!isValid) return null
            const id = String(el.value)
              .split('')
              .map((char) => char.toLowerCase().charCodeAt(0))
              .reduce((acc, curr) => acc + curr, 0)
            return {
              id,
              title: el.value,
              value: el.data.settlement || el.data.city,
            }
          })
          .filter((el: any) => !!el)
      },
      function (error) {
        return Promise.reject(error)
      }
    )

    const fetchSuggestions = async () => {
      try {
        pending.value = true
        return await suggestionsClient.post(suggestionsUrl, {
          count: 10,
          language: 'ru',
          query: search.value,
        })
      } catch (e) {
        Logger.error(e)
      } finally {
        pending.value = false
      }
    }

    const onFetchCityList = async () => {
      if (canFetch.value) {
        cityList.value = (await fetchSuggestions()) as unknown as unknown[]
      }
    }

    const onSearch = debounce(300, false, async (value: string) => {
      search.value = value
      await onFetchCityList()
    })

    const onSelectCity = (city: string) => {
      emit('select', city)
    }

    return {
      popupProperties,
      cityList,
      pending,
      search,
      isFetchError,
      onSearch,
      onSelectCity,
    }
  },
})
